/* eslint-disable */
import { Middleware } from "@sa/rep-common";
import { DataFlowProcessingState } from "@sa/rep-core";

export const exampleDataflowMiddlewares: Middleware<DataFlowProcessingState> = (input, next) => {
  if (input.reportId === "example") {
    for (const key of input.parameters.keys()) {
    }
  }
  return next(input);
};
